import CustomModal from "../../../components/CustomModal";
import React, {useEffect, useState} from "react";
import LabeledSelect from "../../../components/selects/LabeledSelect";
import CustomButton from "../../../components/CustomButton";
import Checkbox from "../../../components/form/CheckBox";
import {useDispatch, useSelector} from "react-redux";
import useDidMount from "../../../hooks/useDidMount";
import {transferItem} from "../../../redux/slices/dynamicUiSlice";
import {PLATFORM_MOBILE, PLATFORM_WEB} from "../../../constants/commons";
import {UI_TYPE_FOCUSED, UI_FOCUSED_TYPE_BRAND, UI_FOCUSED_TYPE_CATEGORY, UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN} from "../constants";
import {getSelectedDataByPlatform, getUiBreadCrumbFormat} from "../dynamicUiFunctions";

const AddToSelectedModal = ({setShowModal, showModal}) => {
  const [position, setPosition] = useState(defaultPosition);
  const [isQuickee, setIsQuickee] = useState(false);
  const {loading, flag} = useSelector((state) => state.dynamicUi.transferItems);

  const dispatch = useDispatch();

  useDidMount(() => {
    closeModal();
  }, [flag]);

  useEffect(() => {
    return () => {
      clearAll();
    };
  }, []);

  useEffect(() => {
    if (showModal?.is_quickee !== undefined) {
      setIsQuickee(showModal.is_quickee);
    } else {
      setIsQuickee(false);
    }
  }, [showModal]);

  function clearAll() {
    // dispatch((resetAddItems()));
    // setUiType(undefined);
    setIsQuickee(false);
  }

  const closeModal = () => {
    setShowModal();
    clearAll();
  };

  const handleTransferItems = () => {
    dispatch(transferItem({...showModal, priority: position?.priority, is_quickee: isQuickee}));
  };


  const isRemove = !!showModal?.remove;
  const isUpdate = !!showModal?.section;
  const isAdd = !!showModal?.type;

  return (
    <CustomModal bodyClasses="max-w-xl" showModal={!!showModal} setShowModal={closeModal}
                 title={isRemove ? 'Remove from UI' : isUpdate ? 'Move to Position' : 'Add to UI'} loading={loading}
                 button={
                   <CustomButton onClick={handleTransferItems} bg={isRemove ? 'error' : 'primary'}
                                 disabled={loading}>
                     {isRemove ? 'Remove' : isUpdate ? 'Move' : 'Add'}
                   </CustomButton>
                 }>

      {isRemove ? 'This item will be removed from the UI. Are you sure ?' : isAdd || isUpdate ?
        <AddContentForm showModal={showModal} loading={loading} position={position} setPosition={setPosition} isQuickee={isQuickee} setIsQuickee={setIsQuickee}/> : ""
      }


    </CustomModal>
  );
};

export default React.memo(AddToSelectedModal);

const AddContentForm = ({loading, showModal, setPosition, position, isQuickee, setIsQuickee}) => {


  // const {data: selectedDataList} = useSelector((state) => state.dynamicUi.selected);

  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage));


  // const {loading, data, init, error} = useSelector((state) => state.dynamicUi.selected);
  const {
    data: selectedDataList
  } = useSelector((state) => state.dynamicUi.selected[selectedPage]) ?? {};


  const isPlatformMobile = useSelector((state) => state.dynamicUi.isPlatformMobile);

  const platformWiseSelectedData = getSelectedDataByPlatform(selectedDataList, isPlatformMobile ? PLATFORM_MOBILE : PLATFORM_WEB);

  const isUpdate = showModal.position !== undefined;

  useEffect(() => {
    if (showModal) {
      setPosition(isUpdate ? {
        value: showModal.position + 1,
        label: showModal.position + 1,
        priority: platformWiseSelectedData[showModal.position].priority + (showModal.pr ?? 0)
      } : defaultPosition);
    }

  }, [showModal]);

  const getPositions = (total = platformWiseSelectedData.length) =>
    [...Array.from({length: total + (isUpdate ? 0 : 1)}, (_, i) => ({

      label: i === 0 ? 'First' : i === platformWiseSelectedData.length - (isUpdate ? 1 : 0) ? 'Last' : i + 1,
      disabled: i === showModal.disabled,

      ...(i < platformWiseSelectedData.length && {priority: platformWiseSelectedData[i].priority + (i > showModal.disabled ? 1 : 0)}),
      value: isUpdate || i !== platformWiseSelectedData.length ? i + 1 : undefined
    }))];

  return (
    <>
      <div className="flex justify-between">
        <div className="ml-1 text-sm text-gray-600 font-bold">Position</div>
        <div className="ml-1 text-sm text-gray-600 text-xs">{getUiBreadCrumbFormat(showModal)}</div>

      </div>

      <LabeledSelect options={getPositions()} value={position} onChange={setPosition}
                     isOptionDisabled={(option) => option.disabled}
                     isDisabled={loading} className="w-full space-y-1 mb-4 md:mb-0"/>

      {showModal?.type === UI_TYPE_FOCUSED && 
       [UI_FOCUSED_TYPE_BRAND, UI_FOCUSED_TYPE_CATEGORY, UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN].includes(showModal?.sub_type) && (
        <div className="mt-4">
          <Checkbox
            name="is_quickee"
            value="is_quickee"
            label="Is Quickee"
            isChecked={isQuickee}
            onChanged={() => setIsQuickee(!isQuickee)}
          />
        </div>
      )}
    </>
  );
};
const defaultPosition = {value: undefined, label: 'Last'};

